<template>
  <div style="border-top: 1px #e1e4e8 solid !important;padding: 45px 0px 45px 0px;">
    <el-row>
      <el-col :span="10">
        <div>
          © 2020 &emsp;<a href="https://beian.miit.gov.cn/" target="_blank">粤ICP备2020098280号</a>&emsp;
          <a href="https://github.com/jzclem" target="_blank">jzclem</a>&emsp;&emsp;
          <a href="https://github.com/jzclem/blog" target="_blank">Blog</a>
        </div>
      </el-col>
      <el-col :span="4">
        <div style="text-align: center;font-size: 18px">
          <i class="el-icon-location-outline"></i>
        </div>
      </el-col>
      <el-col :span="10">
        <div style="float: right;">
          <a href="https://developer.github.com" target="_blank">GitHub-API</a>&emsp;&emsp;
          <a href="https://cn.vuejs.org/" target="_blank">Vue.js</a>&emsp;&emsp;
          <a href="http://element.eleme.io/" target="_blank">Element</a>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
  export default {
    data () {
      return {}
    },
    methods: {}
  }
</script>



// WEBPACK FOOTER //
// src/views/layout/components/Foot.vue